<template>
  <div>
    <MemberHeader0 />
    <router-view />
    <AdminFooter />
  </div>
</template>

<script>
import MemberHeader0 from '@/views/admin/MemberHeader0.vue';
import AdminFooter from '@/views/admin/adminFooter.vue';

export default {
  name: 'AdminLayout',
  components: {
    MemberHeader0,
    AdminFooter
  }
}
</script>
